import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";

import { HistoryLogSidePanelRoutingModule } from "./history-log-side-panel-routing.module";
import { SlidingPanelModule } from "@shared/components/sliding-panel/sliding-panel.module";
import { HistoryLogSidePanelComponent } from "./container/history-log-side-panel.component";
import { IconModule } from "../icon/icon.module";
import { PipesModule } from "@shared/pipes/pipes.module";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { NoItemsLayoutModule } from "../no-items-layout/no-items-layout.module";
import { MatDividerModule } from "@angular/material/divider";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "@shared/shared.module";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatTabsModule } from "@angular/material/tabs";
import { OrdinalDatePipe } from "@shared/pipes/common/ordinal-date.pipe";
import { MilestoneStatusesPipe } from "@shared/pipes/common/milestone-statuses.pipe";

@NgModule({
	declarations: [HistoryLogSidePanelComponent],
	exports: [HistoryLogSidePanelComponent],
	imports: [
		SharedModule,
		CommonModule,
		HistoryLogSidePanelRoutingModule,
		SlidingPanelModule,
		IconModule,
		PipesModule,
		MatFormFieldModule,
		NoItemsLayoutModule,
		MatDividerModule,
		FormsModule,
		ReactiveFormsModule,
		MatInputModule,
		MatTabsModule
	],
	providers: [DatePipe, OrdinalDatePipe, MilestoneStatusesPipe]
})
export class HistoryLogSidePanelModule {}
